import { gql } from '@apollo/client'
import { BodyText, Button, Card, Heading } from '@farol-ds/react'
import classNames from 'classnames'
import { HTMLAttributes } from 'react'

import { useChooseFrequencyLaterEvents } from '../../../../hooks/use-choose-frequency-later-events'
import { BenefitsList } from '../../../dynamic-multiple-offers-switch-frequency-new-benefits-lock/components/benefits-list'
import { LockIcon } from '../../../dynamic-multiple-offers-switch-frequency-new-benefits-lock/components/lock-icon'
import { ChooseFrequencyLaterOfferCard_OfferLockCardFragment } from './__generated__/choose-frequency-later-offer-card.graphql'
import styles from './choose-frequency-later-offer-card.module.scss'
import { ChooseFrequencyLaterOfferCardPrice } from './choose-frequency-later-offer-card-price'

export interface ChooseFrequencyLaterOfferCardProps extends HTMLAttributes<HTMLDivElement> {
  offerLockCard: ChooseFrequencyLaterOfferCard_OfferLockCardFragment
  className?: string
  onBtnClick: (title: string) => void
}

export function ChooseFrequencyLaterOfferCard({
  offerLockCard,
  className,
  onBtnClick,
}: ChooseFrequencyLaterOfferCardProps) {
  const { title, subtitle, offer, buttons, icon } = offerLockCard
  const { isRecommendedOffer } = offer
  const { label, kind } = buttons[0] || {}
  const buttonKind = kind || 'primary'
  const buttonLabel = label || 'Escolher plano'

  const { metricsRef, sendPlanSelectedEvent } = useChooseFrequencyLaterEvents()

  function handleSelectOffer() {
    sendPlanSelectedEvent(title, offerLockCard)
    onBtnClick(offerLockCard.title)
  }

  return (
    <div
      className={classNames(styles.container, className, {
        [styles.recommendedContainer]: isRecommendedOffer,
      })}
    >
      <BodyText size="md" className={styles.recommendedText}>
        {isRecommendedOffer && 'Recomendado'}
      </BodyText>

      <Card className={styles.content}>
        <div className={styles.header}>
          <div className={styles.headerTitleContainer}>
            <div className={styles.headerTitle}>
              <LockIcon icon={icon} />
              <Heading size="md">{title}</Heading>
            </div>
          </div>

          <BodyText size="md">{subtitle}</BodyText>
        </div>

        <ChooseFrequencyLaterOfferCardPrice offerLockOffer={offer} />

        <div className={styles.paymentButtons}>
          <Button kind={buttonKind} onClick={handleSelectOffer} ref={metricsRef}>
            {buttonLabel}
          </Button>
        </div>

        <div>
          <BenefitsList offerLockCard={offerLockCard} />
        </div>
      </Card>
    </div>
  )
}

ChooseFrequencyLaterOfferCard.fragments = {
  offerLockCard: gql`
    fragment ChooseFrequencyLaterOfferCard_offerLockCard on OfferLockCard {
      title
      subtitle
      icon {
        ...LockIcon_offerLockIcon
      }
      offer {
        isRecommendedOffer
        priceAfterPromotionalPeriodText
        ...ChooseFrequencyLaterOfferCardPrice_offerLockOffer
      }
      buttons {
        label
        kind
      }
      ...NewBenefitsList_offerLockCard
      ...UseChooseFrequencyLaterEvents_offerLockCard
    }
    ${LockIcon.fragments.icon}
    ${ChooseFrequencyLaterOfferCardPrice.fragments.offerLockOffer}
    ${BenefitsList.fragments.offerLockCard}
    ${useChooseFrequencyLaterEvents.fragments.offerLockCard}
  `,
}
